module.exports = __webpack_public_path__ + "img/box-jin.2cf2310b.png";